import { FacetElementData } from "@/lib/factfinder/factfinder-interfaces"

const naturalCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
})

function getLeadingNumberSortInfo(value: string): { number: number; operatorWeight: number } | undefined {
  const match = value.trim().match(/^([<>]=?|≤|≥)?\s*(\d+(?:[.,]\d+)?)/)
  if (!match) {
    return undefined
  }

  const operator = match[1]
  const operatorWeight =
    operator === "<" || operator === "≤" ? -1 : operator === ">" || operator === ">=" || operator === "≥" ? 1 : 0

  return {
    number: Number.parseFloat(match[2].replace(",", ".")),
    operatorWeight,
  }
}

export function compareNaturalValues(a: string, b: string): number {
  const numberInfoA = getLeadingNumberSortInfo(a)
  const numberInfoB = getLeadingNumberSortInfo(b)

  if (numberInfoA && numberInfoB) {
    return (
      numberInfoA.number - numberInfoB.number ||
      numberInfoA.operatorWeight - numberInfoB.operatorWeight ||
      naturalCollator.compare(a, b)
    )
  }

  return naturalCollator.compare(a, b)
}

export function noSort(a: FacetElementData, b: FacetElementData): number {
  return 1
}

export function sortByHitCount(a: FacetElementData, b: FacetElementData): number {
  return b.hitcount - a.hitcount
}

export function sortByAlphanumeric(a: FacetElementData, b: FacetElementData): number {
  return compareNaturalValues(a.elementname, b.elementname)
}

export function sortBySelectedAlphanumeric(a: FacetElementData, b: FacetElementData): number {
  const hasHitsA: number = a.hitcount > 0 ? 1 : 0
  const hasHitsB: number = b.hitcount > 0 ? 1 : 0

  return hasHitsB - hasHitsA || compareNaturalValues(a.elementname, b.elementname)
}

export function sortByNumeric(a: FacetElementData, b: FacetElementData): number {
  return compareNaturalValues(a.elementname, b.elementname)
}

export function sortBySelectedNumeric(a: FacetElementData, b: FacetElementData): number {
  const hasHitsA: number = a.hitcount > 0 ? 1 : 0
  const hasHitsB: number = b.hitcount > 0 ? 1 : 0

  return hasHitsB - hasHitsA || compareNaturalValues(a.elementname, b.elementname)
}

export function sortByMinShipmentDays(a: FacetElementData, b: FacetElementData): number {
  if (a.minShipmentDays === undefined) {
    return 1
  }
  if (b.minShipmentDays === undefined) {
    return -1
  }
  return a.minShipmentDays - b.minShipmentDays
}
